module.exports = __webpack_public_path__ + "img/menu.9751a651.svg";